import React from 'react';
import styled from 'styled-components';

import { Card } from '@material-ui/core';
import { AttachFile as AttachFileIcon } from '@material-ui/icons';

import { Attachment } from '../../../common/attachment/Attachment.interface';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InputFile from '../../../common/forms/InputFile';
import { InlineFileValue } from '../../../common/inline/InlineFile';

const StyledInputFile = styled(InputFile)`
  .drag-empty-container {
    margin: 8px 16px 16px;
  }
  .input-file-table {
    border: unset;
    border-radius: unset;
  }
`;

export interface UserAttachmentCardProps {
  attachments: Attachment[];
  isLoading?: boolean;
  onChange: (attachments: InlineFileValue[]) => void;
}

const UserAttachmentCard: React.FC<UserAttachmentCardProps> = ({
  attachments,
  isLoading,
  onChange
}) => {
  return (
    <Card>
      <CardTitle>
        <AttachFileIcon />
        Attachments
      </CardTitle>
      <CardContent style={{ padding: 0 }}>
        <StyledInputFile
          multiple
          isLoading={isLoading}
          disabled={isLoading}
          uploadPath='attachments'
          values={attachments}
          onChange={onChange}
        />
      </CardContent>
    </Card>
  );
};

export default UserAttachmentCard;
